import convertNumberToPersianUnits from "../../../../utilities/helper/unitConvertor/convertNumberToPersianUnit";
import ConvertNotifTypeToPersian from "../../utils/convertNotifTypeToPersian";


const OldPlanBox = (props: sponserItem) => {
  const {
    link,
    text,
    number_messages,
    notification_type,
    sponsoring_message_unit,
  } = props;
  return (
    <div className="bg-gray-50 rounded-lg px-6 py-4 flex flex-col gap-2 text-gray-800 text-sm">
      <p className="mb-0">
        <span>
          {convertNumberToPersianUnits(
            sponsoring_message_unit.notification_count,
          )}
        </span>
        <span>پیام {ConvertNotifTypeToPersian(notification_type)} </span>
      </p>
      <p className="mb-0">
        <span className="text-gray-700 inline-block ml-1">
          مشاهده پیام‌ها توسط
        </span>
        <span>{number_messages.message_viewer} نفر</span>
      </p>
      <p className="mb-0">
        <span className="text-gray-700 inline-block ml-1">
          ورود به صفحه تبلیغی
        </span>
        <span>{number_messages.login_advertising_page} نفر</span>
      </p>
      <p className="mb-0 w-full flex gap-1 ">
        <span className="text-gray-700 shrink-0">لینک صفحه تبلیغی</span>
        <span className="flex-1 line-clamp-1 overflow-ellipsis" dir="ltr">
          {link.toString()}
        </span>
      </p>
      <p className="mb-0">
        <span className="text-gray-700 inline-block ml-1">متن تبلیغی</span>
        <span>{text}</span>
      </p>
    </div>
  );
};

export default OldPlanBox;
